import React, { useEffect, useContext } from 'react';

import './Products.css';
import fetchProducts from '../../api/fetchProducts';
import ProductCard from '../ProductCard/ProductCard';
import Loading from '../Loading/Loading';
import AppContext from '../../context/AppContext';

function Products() {

	const {products, setProducts, setLoading, loading} = useContext(AppContext);
	

	useEffect(() => {
		fetchProducts('iphone').then((response) => {
			setProducts(response);
			setLoading(false); 
		});
	}, []);

	return (
		(loading ? <Loading /> : <section className="products conteiner">
			{
				products.map((product) => <ProductCard key={product.id} data={product}/>)
			}
		</section>)
	);
}

export default Products;
